/**
 * Transformed Job Listings response as required from the redux store
 * @param {Object} data - Job Listings response
 * @param {String} currencySymbol - Currency Symbol
 */

const TransformJobListings = ({
	data: jobLists,
	currency_symbol: currencySymbol,
	total_pages: totalPages,
	page: currentPage,
}) => {
	const jobs = jobLists?.map((job) => {
		// generate string concated values for job types, job categories and salary
		const jobTypesString = job.job_types
			?.map((jobType) => jobType.name)
			.join(', ');

		const jobCategoriesString = job.job_categories
			?.map((jobCategory) => jobCategory.name)
			.join(', ');

		const jobSalary = job.salary.formatted || '';

		const jobLocations = job.locations.join(', ');
		// return response
		return {
			id: job.id,
			logo_url: job.logo,
			job_title: job.title,
			job_url: job.link,
			company_name: job.company_name,
			posted_date: job.posted,
			modified_date: job.post_modified,
			pin_lists: [jobLocations, jobTypesString, jobCategoriesString, jobSalary],
			is_external_link: job.is_external,
			is_easy_apply: job.easy_apply,
		};
	});

	return { jobs, totalPages, currentPage };
};

export default TransformJobListings;
